import { useParams } from 'react-router-dom';
import {
  ButtonPseudo,
  PermissionDenied,
  PermissionEnum,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
} from '@ui/src';
import { useAppSelector } from '@store';
import useAgreement from '../hooks/use-agreement';
import getAgreementTypeName from '../../../new-application/helpers/get-agreement-type-name';
import AgreementForm from '../../../../components/common/agreements/agreement';
import { AgreementTypes } from '../types';

import cn from '../styles.module.css';

const Agreement = ({ customerType, isApplication }: AgreementTypes) => {
  const { agreement } = useAppSelector((state) => state.customerDocuments);
  const { activePermissions } = useAppSelector((state) => state.root);
  const { agreementId, customerId } = useParams();

  const { isLoading, isFetching, link, panelIsOpen, handleClose } =
    useAgreement({
      customerType,
      customerId,
      agreementId,
      isApplication,
      activePermissions,
    });

  let content;

  if (!activePermissions?.includes(PermissionEnum.AGREEMENTS_LIST)) {
    content = <PermissionDenied />;
  } else {
    // eslint-disable-next-line no-lonely-if
    if (isLoading || isFetching) {
      content = <SidePanelLoader />;
    } else {
      content = (
        <>
          {agreement?.uploadId && (
            <div className={cn.file}>
              <div
                className={`${cn.fileName} ${
                  agreementId ? cn.fileNameFullWidth : ''
                }`}
              >
                {agreement && link && (
                  <a
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                  >{`${getAgreementTypeName(
                    agreement?.type,
                  )} (v${agreement.version})`}</a>
                )}
                {!link && 'Loading...'}
              </div>
            </div>
          )}
          <div className={cn.agreementFormSeparator} />
          <AgreementForm agreement={agreement} agreementId={agreementId} />
        </>
      );
    }
  }

  let title;

  if (agreement) {
    title = getAgreementTypeName(agreement?.type);
  } else {
    title = 'Agreement';
  }

  return (
    <SidePanel
      type={SidePanelType.AML}
      closeOnClickOutside
      isOpen={panelIsOpen}
      onClose={handleClose}
      title={title}
      footer={<ButtonPseudo text="Close" onClick={handleClose} bold />}
      sidepanelExpandedKey="customers-agreements"
    >
      {content}
    </SidePanel>
  );
};

export default Agreement;
